/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".divunsuscribe[_ngcontent-%COMP%]{max-width:600px;padding:3% 10px;text-align:center;margin:auto;box-shadow:0 2px 9px 0 rgba(0,0,0,.02);min-height:100px;font-weight:700}\n/*# sourceMappingURL=unsubscribe.component.css.map*/"];
export { styles as styles };
